import classNames from "classnames";
import {
  type ImgHTMLAttributes,
  type ReactNode,
  useEffect,
  useState,
} from "react";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src?: string | null;
  fallback?: ReactNode;
};

export default function ImageWithFallback({
  fallback,
  className,
  src,
  ...rest
}: Props) {
  const [showAlt, setShowAlt] = useState(!src);

  useEffect(() => {
    setShowAlt(!src);
  }, [src]);

  return (
    <>
      {showAlt && fallback}
      {src && (
        <img
          className={classNames(showAlt && "hidden", className)}
          src={src}
          {...rest}
          onLoad={(e) => {
            setShowAlt(false);
            rest.onLoad?.(e);
          }}
          onError={(e) => {
            rest.onError?.(e);
            if (fallback) {
              setShowAlt(true);
            }
          }}
        />
      )}
    </>
  );
}
